/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
    Terminal,
    TerminalFromJSON,
    TerminalToJSON,
    TerminalConnectionToken,
    TerminalConnectionTokenFromJSON,
    TerminalConnectionTokenToJSON,
    TerminalCreateParams,
    TerminalCreateParamsFromJSON,
    TerminalCreateParamsToJSON,
    TerminalDeviceType,
    TerminalDeviceTypeFromJSON,
    TerminalDeviceTypeToJSON,
    TerminalList,
    TerminalListFromJSON,
    TerminalListToJSON,
    TerminalLocation,
    TerminalLocationFromJSON,
    TerminalLocationToJSON,
    TerminalRequestParams,
    TerminalRequestParamsFromJSON,
    TerminalRequestParamsToJSON,
    TerminalStatus,
    TerminalStatusFromJSON,
    TerminalStatusToJSON,
    TerminalUpdateParams,
    TerminalUpdateParamsFromJSON,
    TerminalUpdateParamsToJSON,
} from '../models';

export interface ConnectTerminalRequest {
    program_id: string;
}

export interface CreateTerminalRequest {
    program_id: string;
    TerminalCreateParams: TerminalCreateParams;
}

export interface DeleteTerminalRequest {
    program_id: string;
    id: string;
}

export interface FindOneTerminalRequest {
    program_id: string;
    id: string;
}

export interface FindTerminalsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    status?: TerminalStatus;
    device_type?: TerminalDeviceType;
}

export interface RequestTerminalRequest {
    program_id: string;
    TerminalRequestParams: TerminalRequestParams;
}

export interface UpdateTerminalRequest {
    program_id: string;
    id: string;
    TerminalUpdateParams: TerminalUpdateParams;
}

/**
 * 
 */
export class TerminalsApi extends runtime.BaseAPI {

    /**
     * Create terminal connection token
     */
    async connectTerminalRaw(requestParameters: ConnectTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<TerminalConnectionToken>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling connectTerminal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/terminals/connection_token`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalConnectionTokenFromJSON(jsonValue));
    }

    /**
     * Create terminal connection token
     */
    async connectTerminal(requestParameters: ConnectTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<TerminalConnectionToken> {
        const response = await this.connectTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Terminal
     */
    async createTerminalRaw(requestParameters: CreateTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Terminal>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createTerminal.');
        }

        if (requestParameters.TerminalCreateParams === null || requestParameters.TerminalCreateParams === undefined) {
            throw new runtime.RequiredError('TerminalCreateParams','Required parameter requestParameters.TerminalCreateParams was null or undefined when calling createTerminal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/terminals`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TerminalCreateParamsToJSON(requestParameters.TerminalCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalFromJSON(jsonValue));
    }

    /**
     * Create Terminal
     */
    async createTerminal(requestParameters: CreateTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Terminal> {
        const response = await this.createTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Terminal
     */
    async deleteTerminalRaw(requestParameters: DeleteTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteTerminal.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteTerminal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/terminals/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete Terminal
     */
    async deleteTerminal(requestParameters: DeleteTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find Terminal by id
     */
    async findOneTerminalRaw(requestParameters: FindOneTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Terminal>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneTerminal.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findOneTerminal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/terminals/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalFromJSON(jsonValue));
    }

    /**
     * Find Terminal by id
     */
    async findOneTerminal(requestParameters: FindOneTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Terminal> {
        const response = await this.findOneTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all Terminals
     */
    async findTerminalsRaw(requestParameters: FindTerminalsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<TerminalList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findTerminals.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.device_type !== undefined) {
            queryParameters['device_type'] = requestParameters.device_type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/terminals`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalListFromJSON(jsonValue));
    }

    /**
     * List all Terminals
     */
    async findTerminals(requestParameters: FindTerminalsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<TerminalList> {
        const response = await this.findTerminalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Request new terminal for program
     */
    async requestTerminalRaw(requestParameters: RequestTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<TerminalLocation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling requestTerminal.');
        }

        if (requestParameters.TerminalRequestParams === null || requestParameters.TerminalRequestParams === undefined) {
            throw new runtime.RequiredError('TerminalRequestParams','Required parameter requestParameters.TerminalRequestParams was null or undefined when calling requestTerminal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/terminals/request`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TerminalRequestParamsToJSON(requestParameters.TerminalRequestParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalLocationFromJSON(jsonValue));
    }

    /**
     * Request new terminal for program
     */
    async requestTerminal(requestParameters: RequestTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<TerminalLocation> {
        const response = await this.requestTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Terminal
     */
    async updateTerminalRaw(requestParameters: UpdateTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Terminal>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateTerminal.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateTerminal.');
        }

        if (requestParameters.TerminalUpdateParams === null || requestParameters.TerminalUpdateParams === undefined) {
            throw new runtime.RequiredError('TerminalUpdateParams','Required parameter requestParameters.TerminalUpdateParams was null or undefined when calling updateTerminal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/terminals/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TerminalUpdateParamsToJSON(requestParameters.TerminalUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalFromJSON(jsonValue));
    }

    /**
     * Update Terminal
     */
    async updateTerminal(requestParameters: UpdateTerminalRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Terminal> {
        const response = await this.updateTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
